import { render, staticRenderFns } from "./AssignFinalAFCFTANumber.vue?vue&type=template&id=1aae353b&"
import script from "./AssignFinalAFCFTANumber.vue?vue&type=script&lang=js&"
export * from "./AssignFinalAFCFTANumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports